import { createFileRoute } from "@tanstack/react-router";

import { DefaultToolsPanel } from "../components/settings/DefaultToolsPanel";

function SettingsToolsRoute() {
  return <DefaultToolsPanel />;
}

export const Route = createFileRoute("/settings/tools")({
  component: SettingsToolsRoute,
});
